var text = {
    group: 'inline',
    toDebugString: 
    // @ts-ignore
    process.env.NODE_ENV !== 'production' ? undefined : function () { return 'text_node'; },
};

export { text };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/text.js